interface BackgroundPictureSource {
  srcSet: string
  type: string
  media?: string
}

interface BackgroundPictureProps {
  sources: BackgroundPictureSource[]
  fallbackSrc: string
  className?: string
  imgClassName?: string
  objectPositionClassName?: string
}

export default function BackgroundPicture({
  sources,
  fallbackSrc,
  className = 'absolute inset-0',
  imgClassName = '',
  objectPositionClassName = 'object-center',
}: BackgroundPictureProps) {
  return (
    <picture aria-hidden className={`pointer-events-none ${className}`}>
      {sources.map((source) => (
        <source
          key={`${source.media || 'default'}-${source.type}-${source.srcSet}`}
          media={source.media}
          srcSet={source.srcSet}
          type={source.type}
        />
      ))}
      <img
        src={fallbackSrc}
        alt=""
        className={`h-full w-full object-cover ${objectPositionClassName} ${imgClassName}`}
      />
    </picture>
  )
}
